export const LOADER_TYPES = { rectangle: 'rectangle', circle: 'circle' }

export const LOADER_CSS_CLASSES = {
  [LOADER_TYPES.rectangle]: 'rounded',
  [LOADER_TYPES.circle]: 'rounded-full'
}

export type LoaderTypesKeys = keyof typeof LOADER_TYPES
export type LoaderTypesValues = (typeof LOADER_TYPES)[LoaderTypesKeys]

export const isHexColor = (hexColor: string) => {
  const hex = hexColor.replace('#', '')
  return typeof hexColor === 'string' && hexColor.startsWith('#') && hex.length === 6 && !isNaN(Number('0x' + hex))
}

export const hexToRgb = (hex: string) => `${hex.match(/\w\w/g)?.map((x) => +`0x${x}`)}`
